import { FunctionsHttpError } from "@supabase/supabase-js";

/**
 * supabase-js's FunctionsHttpError.message is always the generic
 * "Edge Function returned a non-2xx status code" — the actual reason
 * (paywall 403, validation 400, etc.) is in error.context, the raw
 * Response object. This extracts it, falling back to a generic message.
 */
export async function extractFunctionsErrorMessage(
  error: unknown,
  fallback: string,
): Promise<string> {
  if (error instanceof FunctionsHttpError) {
    try {
      const body = await error.context.json();
      if (typeof body?.error === "string") return body.error;
    } catch {
      // response body wasn't JSON — fall through to fallback
    }
  }
  return fallback;
}
